import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FeatureFlags, FeatureName } from 'types/featureFlags';
import { RootState } from 'store';
import config from 'config/common';

type GetFeatures = () => FeatureFlags;

export const useFeatureScripts: GetFeatures = () => {
    const configEnv = useSelector((state: RootState) => state.config.env);

    return useMemo(() => {
        const isSoliticsEnabled =
            config.solitics.isSoliticsEnabled || configEnv?.REACT_APP_FEATURE_FLAGS_SOLITICS_IS_ENABLED || false;

        const isProLineEnabled = !!config.proLine.enabled || !!configEnv?.REACT_APP_FEATURE_FLAGS_PROLINE_IS_ENABLED;

        return {
            [FeatureName.Solitics]: {
                enabled: isSoliticsEnabled,
                position: 'bodyClose',
                type: 'external',
                content: 'https://sdk.solitics.com/oapit.min.js',
            },
            [FeatureName.ProLine]: {
                enabled: isProLineEnabled,
                position: 'bodyClose',
                type: 'external',
                content: configEnv?.REACT_APP_PRO_LINE_SCRIPT || config.proLine.script || '',
            },
        };
    }, [
        configEnv?.REACT_APP_FEATURE_FLAGS_SOLITICS_IS_ENABLED,
        configEnv?.REACT_APP_FEATURE_FLAGS_PROLINE_IS_ENABLED,
        configEnv?.REACT_APP_PRO_LINE_SCRIPT,
    ]);
};
